import * as React from 'react'

import { Formik } from 'formik'
import * as yup from 'yup'

import { ICallTrackingAccount } from '../typings'
import { useSyncHandler } from '../hooks/useSyncHandler'
import { TidalCampaignTrackingForm } from './TidalCampaignTrackingForm'

type Props = {
  id: number
  name: string
  accountId: string
  synced: boolean
}

const validationSchema = yup.object({
  accountId: yup
    .string()
    .required('Required')
    .max(100, `Account Id must be no more than 100 characters`),
  secretKey: yup
    .string()
    .required('Required')
    .max(100, `Secret Key must be no more than 100 characters`),
  accessKey: yup
    .string()
    .required('Required')
    .max(100, `Access Key must be no more than 100 characters`),
})

export function CampaignTrackingInactive(props: Props) {
  const { id, accountId, name } = props

  const { handleSubmit } = useSyncHandler()

  const initialValues: ICallTrackingAccount = {
    accountId: accountId ?? '',
    secretKey: '',
    accessKey: '',
    callTrackingProviderId: id,
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <TidalCampaignTrackingForm name={name} />
    </Formik>
  )
}
